import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { useParams, Navigate } from 'react-router-dom'

import { useScreenMessages } from '@data/i18n'
import { H2, Card, Paragraph } from '@newComponents'
import { GuildDonationScreenContent } from './GuildDonationScreenContent'

import { GuildDonationScreenQuery } from './__generated__/GuildDonationScreenQuery.graphql'

export const GuildDonationScreen = () => {
  useScreenMessages(
    (locale) =>
      import(
        /* webpackChunkName: "locale-guild-donation-screen-[request]" */ `./locales/${locale}.po`
      )
  )
  const params = useParams()

  const data = useLazyLoadQuery<GuildDonationScreenQuery>(
    graphql`
      query GuildDonationScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name
            slugId

            minimumDonationAmount
            donationCurrency

            ...GuildDonationScreenContent_guild
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return <Navigate to='/' replace />
  }

  if (
    !data.nodeBySlugId.donationCurrency ||
    !data.nodeBySlugId.minimumDonationAmount
  ) {
    return <Navigate to={`/${data.nodeBySlugId.slugId}`} />
  }

  return (
    <Card glass gap='$4' main>
      <H2>
        <Trans>Donate to {data.nodeBySlugId.name}</Trans>
      </H2>

      <Paragraph>
        <Trans>
          Set your donation amount below, then enter your payment information.
        </Trans>
      </Paragraph>

      <GuildDonationScreenContent guild={data.nodeBySlugId} />
    </Card>
  )
}

export default GuildDonationScreen
